import { atom } from 'jotai';
import { EPageType } from 'shared/constant/page-type';

interface ISharingPageTraffic {
  canonicalUrl: string;
  pageType: EPageType;
}

export interface IHashtagPageTraffic extends ISharingPageTraffic {
  pageType: EPageType.HASHTAG;
  hashtagId: string;
}

export interface IGalleryPageTraffic extends ISharingPageTraffic {
  pageType: EPageType.Gallery;
  groupId: string;
  mediaId: string;
}

export interface IVideoPageTraffic extends ISharingPageTraffic {
  pageType: EPageType.VIDEO;
  groupId: string;
  mediaId: string;
}

export interface IPOIPageTraffic extends ISharingPageTraffic {
  pageType: EPageType.POI;
  poiId: string;
}

export interface IUserPageTraffic extends ISharingPageTraffic {
  pageType: EPageType.USER;
  userLinkName: string;
  userId: string;
}

export type TPageLevelTraffic =
  | IHashtagPageTraffic
  | IPOIPageTraffic
  | IGalleryPageTraffic
  | IVideoPageTraffic
  | IUserPageTraffic;

export const $SharingPageLevelTraffic = atom({} as TPageLevelTraffic);
$SharingPageLevelTraffic.debugLabel = '$SharingPageLevelTraffic';
